export default "__VITE_ASSET__DTicMpvW__"